import { render } from "./SolutionsPage.vue?vue&type=template&id=5e66af60&scoped=true"
import script from "./SolutionsPage.vue?vue&type=script&lang=js"
export * from "./SolutionsPage.vue?vue&type=script&lang=js"

import "./SolutionsPage.vue?vue&type=style&index=0&id=5e66af60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e66af60"]])

export default __exports__